<template>
    <div class="land-item" :class="{[`land-item${itemBgs[index]}`]:true, 'no-box-shadow': !noshadow}">
        <div class="land-title" style="display: flex;">
            <span>{{ name }}</span>
            <div style="position: relative; top: -6px;" v-if="tipText">
              <el-tooltip effect="light" :content="tipText" placement="top">
                <i class="land-title-tips iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
              </el-tooltip>
            </div>
        </div>
        <div class="land-value">{{ `${sum}${process}` }}<span>{{ unit }}</span></div>
        
              <ul style="z-index: 1;">
                
                <li class="ulLi1" :class="`${sum}${process}`.includes('%') ? 'danduUlLi1' : ''">
                    <div v-if="!hiddenCircle" class="land-compare" :style="`margin-top:${top}px`">
                    <span>环比</span>
                    <!-- <span>{{process}}</span> -->
                    <span class="land-compare-value" :class="{ 'increase': item.metricValueMOM < 0, 'reduce': item.metricValueMOM > 0 }">
                    {{ymRate(item.metricValueMOM)}}
                    <!-- <i v-if="item.metricValueMOM !== 0 && item.metricValueMOM !== null" class="iconfont icon-jiantou"></i> -->
                    </span>
                    </div>
                </li>
                <li class="ulLi2" :class="`${sum}${process}`.includes('%') ? 'danduUlLi2' : ''">
                    <div v-if="item.lastYearMetricValue" class="land-compare" :style="`margin-top:${top}px`">   
                        <span>上季度</span>
                        <span class="land-compare-value lastColot">
                            {{item.lastYearMetricValue}}
                            <span :class=" item.lastYearMetricValue.includes('%') ? 'prelastYearNone' : 'prelastYear'"> 元/㎡·月</span>
                        </span>
                    </div>
                </li>
              </ul>
            <ul style="z-index: 1;">
                <li class="ulLi1" :class="`${sum}${process}`.includes('%') ? 'danduUlLi1' : ''">
                    <div v-if="!hiddenSame" class="land-compare" :style="`margin-top:${top}px`">
                        <span>同比</span>
                        <span class="land-compare-value" :class="{ 'increase': item.metricValueYOY < 0, 'reduce': item.metricValueYOY > 0 }">
                        {{ymRate(item.metricValueYOY)}}
                        <!-- <i v-if="item.metricValueYOY !== 0 && item.metricValueYOY !== null" class="iconfont icon-jiantou"></i> -->
                        </span>
                    </div>
                </li>
                <li class="ulLi2" :class="`${sum}${process}`.includes('%') ? 'danduUlLi2' : ''">
                    <div v-if="item.lastQuarterMetricValue" class="land-compare" :style="`margin-top:${top}px`">
                        <span>上一年</span>
                        <span class="land-compare-value lastColot">
                            {{item.lastQuarterMetricValue}}
                            <span :class=" item.lastQuarterMetricValue.includes('%') ? 'prelastYearNone' : 'prelastYear'"> 元/㎡·月</span>
                        </span>
                    </div>
                </li>
            </ul>

        
        
        <div class="land-item-icon" :class="{[`land-item-icon${itemBgs[index]}`]: true}"></div>
    </div>
</template>
<script setup>

import { computed } from "vue";
import {ymRate} from "../tool/number";
import {toPercent} from "../tool/number";

const props = defineProps({
    hiddenSame: {
      type: Boolean,
      default: false
    },
    hiddenCircle: {
      type: Boolean,
      default: false
    },
    lastQuarterMetricValue: {
      type: Boolean,
      default: false
    },
    item: {
        type: Object,
        default: {}
    },
    /** 标签文字 **/
    name: {
        type: String,
        default: ''
    },
    /** 单位 **/
    unit: {
        type: String,
        default: ''
    },
    process: {
        type: String,
        default: ''
    },
    top: {
        type: Number,
        default: 40
    },
    tipText: {
        type: String,
        default: ''
    },
    decimal: {
        type: Number,
        default: 2
    },
    index: {
        type: Number
    },
    itemBgs: {
        type: Array,
        default: []
    },
    noshadow: {
        type: Boolean,
        default: true
    },
    format: {
        type: Function
    }
})


const sum = computed(() => {
    if(props.format && props.item){
      return props.format(props.item.metricValue);
    }

    let num = Number(props.item?props.item.metricValue:'-')
    if (props.process === '%') {
        num = num * 100
    }
    return props.unit === '㎡' || props.unit === '亩' ? Number(num.toFixed(props.decimal)).toLocaleString() : num.toFixed(props.decimal)
})

</script>
<style lang="less" scoped>
.land-item {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-top: 30px;
    padding-left: 15px;
    line-height: 1;
    box-shadow: -4px 4px 11px 1px rgba(75, 173, 255, 0.2);
    border-radius: 10px;
    position: relative;
    &.no-box-shadow{
        box-shadow:none;
    }
    &.land-item0 {
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(28, 189, 225, 0.5));
    }
    &.land-item1 {
        background: linear-gradient(0deg, rgba(255,255,255,0.5), rgba(255,230,234,0.5), rgba(255,150,166,0.5));
    }
    &.land-item2 {
        background: linear-gradient(0deg, rgba(255,255,255,0.4), rgba(255,192,59,0.4));
    }
    &.land-item3 {
        background: linear-gradient(0deg, rgba(255,255,255,0.32), rgba(42,86,247,0.32));
    }
    &.land-item4 {
        background: linear-gradient(0deg, rgba(255,255,255,0.45), rgba(22,194,160,0.45));
    }
    &.land-item5 {
        background: linear-gradient(0deg, rgba(255,255,255,0.35), rgba(120,61,242,0.35));
    }
    &.land-item6 {
        background: linear-gradient(-4deg, #F4FAFF, #A0D4FF);
    }
    &.land-item7 {
        background: linear-gradient(-4deg, #FDFFE6, #F3EFA5);
    }
    &.land-item8 {
        background: linear-gradient(-4deg, #FFFBF1, #FDE4BE);
    }
    
    .land-item-icon{
        position: absolute;
        right: 12px;
        bottom: 14px;
    }
    .land-item-icon0{
        width: 53px;
        height: 50px;
        background: url('../assets/images/i0.png') no-repeat;
    }

    .land-item-icon1{
        width: 54px;
        height: 64px;
        background: url('../assets/images/i1.png') no-repeat;
    }

    .land-item-icon2{
        width: 55px;
        height: 54px;
        background: url('../assets/images/i2.png') no-repeat;
    }

    .land-item-icon3{
        width: 55px;
        height: 56px;
        background: url('../assets/images/i3.png') no-repeat;
    }

    .land-item-icon4{
        width: 54px;
        height: 52px;
        background: url('../assets/images/i4.png') no-repeat;
    }

    .land-item-icon5{
        width: 51px;
        height: 51px;
        background: url('../assets/images/i5.png') no-repeat;
    }

    .land-item-icon6{
        width: 69px;
        height: 51px;
        background: url('../assets/images/i6.png') no-repeat;
    }

    .land-item-icon7{
        width: 61px;
        height: 54px;
        background: url('../assets/images/i7.png') no-repeat;
    }

    .land-item-icon8{
        width: 57px;
        height: 61px;
        background: url('../assets/images/i8.png') no-repeat;
    }


    .land-title {
        font-size: 14px;
        color: @text-color-title;

        .land-title-tips {
            font-size: 12px;
            color: #666;
            margin-left: 6px;
            font-weight: bold;
        }
    }

    .land-value {
        font-size: 24px;
        font-weight: bold;
        color: @text-color-title;
        margin-top: 14px;

        &>span {
            font-size: 12px;
            color: @text-color-primary;
        }
    }

    .land-compare {
        //margin-top: 40px;
        font-size: 12px;
        color: @text-color-primary;
        display: flex;
        flex-direction: column;
        font-weight: bold;
    }

    .land-compare-value {
        font-size: 16px;
        font-weight: 400;
        margin-top: 6px;
        width: 80px;
        display: flex;
        font-weight: bold;
        justify-content: space-between;

    }

    .reduce {
        color: #F61313;
    }

    .increase {
        color: #03AD03;

        .icon-jiantou {
            transform: rotate(180deg);
        }
    }
}
.ulLi1 {
    float: left;
    width: 38%;
}

.ulLi2 {
    float: left;
    width: 58%;
    margin-left: 1px;
}

.prelastYear {
    display: inline-block;
    font-size: 11px;
}

.prelastYearNone {
    display: none;
    font-size: 11px;
    
}


.lastColot {
    color: #a8a8a8;
    width: 90px !important;
    line-height: 17px;
}

.danduUlLi1 {
    width: 45%;
}

.danduUlLi2 {
    width: 52%;
}
</style>